/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Custom Mega Menu - Hide on Link Click and Page Navigation
 * Fixes issue where mega menu stays visible after navigation
 */
(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuFix);
  } else {
    initMegaMenuFix();
  }

  function initMegaMenuFix() {
    var megaMenuTrigger = document.querySelector('.Header__MegaMenuTrigger');
    var megaMenu = document.querySelector('.CustomMegaMenu');

    if (!megaMenuTrigger || !megaMenu) {
      return;
    }

    // Hide mega menu when any link inside it is clicked
    var megaMenuLinks = megaMenu.querySelectorAll('a');
    megaMenuLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        // Force hide the mega menu immediately
        megaMenu.style.opacity = '0';
        megaMenu.style.visibility = 'hidden';
        megaMenu.style.transform = 'translateY(-15px)';
      });
    });

    // Hide mega menu before page unload (for better UX)
    window.addEventListener('beforeunload', function() {
      if (megaMenu) {
        megaMenu.style.opacity = '0';
        megaMenu.style.visibility = 'hidden';
        megaMenu.style.transform = 'translateY(-15px)';
      }
    });

    // Reset mega menu state when mouse leaves the trigger area
    megaMenuTrigger.addEventListener('mouseleave', function() {
      // Small delay to allow CSS transition
      setTimeout(function() {
        megaMenu.style.opacity = '';
        megaMenu.style.visibility = '';
        megaMenu.style.transform = '';
      }, 300);
    });
  }
})();

/**
 * Product Page Header Hide on Scroll (Desktop Only)
 * When enabled, hides header when scrolling down and shows when scrolling up
 */
(function() {
  // Check if feature is enabled
  if (!window.theme || !window.theme.productPageHeaderHideOnScroll) {
    return;
  }

  // Check if we're on a product page
  var body = document.body;
  if (!body.classList.contains('template-product')) {
    return;
  }

  // Only run on desktop (min-width: 1000px)
  var desktopMediaQuery = window.matchMedia('(min-width: 1000px)');

  var header = document.querySelector('.shopify-section--header');
  if (!header) {
    return;
  }

  var lastScrollTop = 0;
  var headerHeight = header.offsetHeight;
  var isHeaderHidden = false;
  var ticking = false;

  // Add CSS transition for smooth animation
  header.style.transition = 'transform 0.3s ease-in-out';
  header.style.willChange = 'transform';

  function updateHeader() {
    // Only apply on desktop
    if (!desktopMediaQuery.matches) {
      // Reset header position on mobile/tablet
      header.style.transform = 'translateY(0)';
      isHeaderHidden = false;
      return;
    }

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Scrolling down
    if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
      if (!isHeaderHidden) {
        header.style.transform = 'translateY(-100%)';
        isHeaderHidden = true;
      }
    }
    // Scrolling up
    else if (scrollTop < lastScrollTop) {
      if (isHeaderHidden) {
        header.style.transform = 'translateY(0)';
        isHeaderHidden = false;
      }
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  // Listen for scroll events
  window.addEventListener('scroll', onScroll, { passive: true });

  // Listen for resize to handle desktop/mobile switch
  desktopMediaQuery.addEventListener('change', function() {
    if (!desktopMediaQuery.matches) {
      header.style.transform = 'translateY(0)';
      isHeaderHidden = false;
    }
  });
})();

/**
 * Native Wishlist (isalori_wishlist) — global controller
 * ------------------------------------------------------------------
 * Makes the theme's own heart icons (.ProductItem__Wishlist) work on EVERY
 * page through event delegation. Previously the click logic lived only inside
 * sections/main-collection.liquid, so hearts on the homepage, recommendations,
 * recently-viewed, etc. did nothing. Saved items are shown in the cart drawer
 * "Wishlist" tab (see snippets/cart-drawer.liquid).
 *
 * Any element with class `ProductItem__Wishlist` and a `data-product-handle`
 * attribute becomes a working toggle automatically.
 */
(function() {
  var KEY = 'isalori_wishlist';

  function getItems() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function setItems(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
  }
  function indexOf(items, handle) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].handle === handle) { return i; }
    }
    return -1;
  }

  function syncIcons() {
    var saved = getItems();
    document.querySelectorAll('.ProductItem__Wishlist[data-product-handle]').forEach(function(btn) {
      if (indexOf(saved, btn.dataset.productHandle) !== -1) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  function showToast(msg) {
    var t = document.getElementById('isalori-wl-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'isalori-wl-toast';
      t.className = 'WishlistToast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._tmr);
    t._tmr = setTimeout(function() { t.classList.remove('is-visible'); }, 2000);
  }

  function toggle(btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) { return; }
    var items = getItems();
    var idx = indexOf(items, handle);
    if (idx !== -1) {
      items.splice(idx, 1);
      setItems(items);
      showToast('Removed from wishlist');
    } else {
      items.push({
        handle: handle,
        title:  btn.dataset.productTitle || '',
        price:  parseInt(btn.dataset.productPrice, 10) || 0,
        url:    btn.dataset.productUrl   || '/products/' + handle,
        image:  btn.dataset.productImage || ''
      });
      setItems(items);
      showToast('Added to wishlist');
    }
    syncIcons();
    document.dispatchEvent(new CustomEvent('wishlist:changed'));
  }

  // Delegated click — covers product cards added at any time (homepage grids,
  // recommendations, AJAX collection pagination, quick view, etc.). Capture
  // phase so we beat any card-link navigation.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest ? e.target.closest('.ProductItem__Wishlist[data-product-handle]') : null;
    if (!btn) { return; }
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }, true);

  // Inject styles once: the toast, plus hiding the Wishlist Guru app's injected
  // collection heart so only the theme's native heart remains on product cards.
  if (!document.getElementById('isalori-wl-style')) {
    var style = document.createElement('style');
    style.id = 'isalori-wl-style';
    style.textContent =
      '.WishlistToast{position:fixed;bottom:90px;left:50%;transform:translateX(-50%) translateY(20px);background:#111;color:#fff;padding:10px 20px;border-radius:50px;font-size:13px;font-weight:500;white-space:nowrap;z-index:9999;opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;}' +
      '.WishlistToast.is-visible{opacity:1;transform:translateX(-50%) translateY(0);}' +
      '.wf-wishlist-collection-icon{display:none !important;}';
    document.head.appendChild(style);
  }

  // Public API (used by the cart drawer wishlist tab / header, if wired)
  window.IsaloriWishlist = {
    KEY: KEY,
    getItems: getItems,
    count: function() { return getItems().length; },
    sync: syncIcons
  };

  function boot() { syncIcons(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('wishlist:changed', syncIcons);
  document.addEventListener('shopify:section:load', syncIcons); // theme editor / AJAX re-render
})();

/**
 * Single-variant quick add
 * ------------------------------------------------------------------
 * The "+" on product cards that have no variants to choose. Clicking it adds
 * the product's only variant straight to the cart (multi-variant cards keep
 * their existing "open the size panel" behaviour, handled per-section).
 */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest ? e.target.closest('.ProductItem__VariantToggle[data-add-variant-id]') : null;
    if (!btn) { return; }
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-add-variant-id');
    if (!id || btn.dataset.adding === '1') { return; }

    btn.dataset.adding = '1';
    btn.style.opacity = '0.4';
    btn.style.pointerEvents = 'none';

    function reset() {
      btn.dataset.adding = '';
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        reset();
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: data, quantity: 1 }
        }));
      })
      .catch(reset);
  }, true);
})();